<template>
  <!--分页组件-->
  <div class="pagination">
    <!--上一页-->
    <button class="prev" @click="prePage" :disabled="currentPage === 1">
      上一页
    </button>
    <!--总页数小于8的-->
    <template v-if="config.pageTotal <= showPageNum">
      <button
        class="btn"
        v-for="i in config.pageTotal"
        @click="changeCurrentPage(i)"
        :class="{ active: i === currentPage }"
        :key="i"
      >
        {{ i }}
      </button>
    </template>
    <template v-else-if="currentPage < 4">
      <button
        class="btn"
        v-for="i in 6"
        @click="changeCurrentPage(i)"
        :class="{ active: i === currentPage }"
        :key="i"
      >
        {{ i }}
      </button>
      <button class="btn" :disabled="true">···</button>
      <button class="btn" @click="changeCurrentPage(config.pageTotal)">
        {{ config.pageTotal }}
      </button>
    </template>
    <template v-else-if="currentPage > config.pageTotal - 4">
      <button class="btn" @click="changeCurrentPage(1)">1</button>
      <button class="btn" :disabled="true">···</button>
      <button
        class="btn"
        v-for="i in 6"
        @click="changeCurrentPage(i + (config.pageTotal - 6))"
        :class="{ active: i + (config.pageTotal - 6) === currentPage }"
        :key="i"
      >
        {{ i + (config.pageTotal - 6) }}
      </button>
    </template>
    <template v-else>
      <button class="btn" @click="changeCurrentPage(1)">1</button>
      <button class="btn" :disabled="true">···</button>
      <button class="btn" @click="changeCurrentPage(currentPage - 2)">
        {{ currentPage - 2 }}
      </button>
      <button class="btn" @click="changeCurrentPage(currentPage - 1)">
        {{ currentPage - 1 }}
      </button>
      <button class="btn active">{{ currentPage }}</button>
      <button class="btn" @click="changeCurrentPage(currentPage + 1)">
        {{ currentPage + 1 }}
      </button>
      <button class="btn" @click="changeCurrentPage(currentPage + 2)">
        {{ currentPage + 2 }}
      </button>
      <button class="btn" :disabled="true">···</button>
      <button class="btn" @click="changeCurrentPage(config.pageTotal)">
        {{ config.pageTotal }}
      </button>
    </template>
    <!--下一页-->
    <button
      class="next"
      @click="nextPage"
      :disabled="currentPage === config.pageTotal"
    >
      下一页
    </button>
    <span class="content">一共{{ config.pageTotal }}页，跳转至</span>
    <input
      v-model="jumpNum"
      class="jump-input"
      type="text"
      @input="handleInput"
    />
    <span class="content">页</span>
    <button class="go" @click="changeJumpNum" :disabled="!canJump">
      go
    </button>
  </div>
</template>

<script>
export default {
  props: {
    // 分页配置
    config: {
      type: Object,
      require: true,
      default() {
        return {
          pageNum: 0, // 当前页的索引
          pageTotal: 0 // 总的页数
        };
      }
    }
  },
  data() {
    return {
      showPageNum: 8,
      currentPage: 0,
      jumpNum: null,
      canJump: false
    };
  },
  created: function() {
    this.currentPage = this.config.pageNum || 0;
  },
  methods: {
    prePage() {
      this.currentPage -= 1;
      this.$emit("changeCurrentPage", this.currentPage);
    },
    nextPage() {
      this.currentPage += 1;
      this.$emit("changeCurrentPage", this.currentPage);
    },
    changeCurrentPage(i) {
      this.currentPage = i;
      this.$emit("changeCurrentPage", this.currentPage);
    },
    handleInput() {
      this.canJump =
        Number.isInteger(parseInt(this.jumpNum)) &&
        this.jumpNum > 0 &&
        this.jumpNum <= this.config.pageTotal;
    },
    changeJumpNum() {
      if (this.canJump) {
        this.currentPage = parseInt(this.jumpNum);
        this.$emit("changeCurrentPage", this.currentPage);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 30px;
  .prev,
  .next {
    width: 87px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    background-color: #fff;
  }
  .jump-input {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    background-color: #fff;
    display: inline-block;
    box-sizing: border-box;
    padding: 5px;
    text-align: center;
  }
  .go {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    background-color: #fff;
    display: inline-block;
    text-align: center;
  }
  .content {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
    line-height: 20px;
    margin: 0 5px;
    display: inline-block;
  }
  .btn {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    margin: 0 5px;
    background-color: #f4f4f5;
    color: #606266;
    outline: none;
    border-radius: 2px;
    padding: 0 4px;
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    border: 0;
    &[disabled] {
      color: #c0c4cc;
      cursor: not-allowed;
    }
    &.active {
      cursor: not-allowed;
      background: rgba(66, 149, 210, 1);
      color: #fff;
    }
  }
}
</style>
